<template>
<form @submit.prevent="submit($event, query)" id="product_form">
    <kt-form-section is_first>
        <kt-row>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-label for="title">
                        {{ $t('label.title') }}
                    </kt-form-label>
                    <kt-form-control
                        id="title"
                        name="title"
                        v-model="query.title"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>
    
    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="amount">
                        {{ $t('label.amount') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="amount"
                        name="amount"
                        v-model="query.amount"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-check
                        style="margin-top:2.5rem;"
                        id="define_amount_by_user"
                        name="define_amount_by_user"
                        v-model="query.define_amount_by_user"
                    >
                        {{ $t('label.define_amount_by_user') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="quantity">
                        {{ $t('label.quantity') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="quantity"
                        name="quantity"
                        v-model="query.quantity"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-check
                        style="margin-top:2.5rem;"
                        id="unlimited"
                        name="unlimited"
                        v-model="query.unlimited"
                    >
                        {{ $t('label.unlimited') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-check
                        id="tax"
                        name="tax"
                        v-model="query.tax"
                    >
                        {{ $t('label.tax') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>
    
    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label for="description">
                        {{ $t('label.description') }}
                    </kt-form-label>
                    <kt-form-textarea
                        id="description"
                        name="description"
                        v-model="query.description"
                    >
                    </kt-form-textarea>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('label.image') }}
                    </kt-form-label>
                    <kt-form-label for="image_file" class="d-block btn btn-secondary btn-wide label-file">
                        <kt-icon type="fa" name="paperclip"></kt-icon>
                        {{ $t('gateway.btn.click_me') }}
                        <input
                            @change="processImageFile" 
                            type="file"
                            hidden
                            name="image"
                            id="image_file"
                            accept="image/*"
                        />
                    </kt-form-label>
                </kt-form-group>
            </kt-col>  
        </kt-row>
    </kt-form-section>

    <h4 :style="{marginBottom: '2rem', marginTop: '3rem'}">{{ $t('message.pay_link_settings') }}</h4>

    <kt-form-section>
        <kt-row>
            <kt-col xs="12">
                <kt-form-group>
                    <kt-form-check
                        id="is_multiple"
                        name="is_multiple"
                        v-model="query.is_multiple"
                    >
                        {{ $t('label.is_multiple') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-check
                        id="address_option"
                        name="address_option"
                        v-model="query.address_option"
                    >
                        {{ $t('label.address_option') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group class="row">
                    <kt-form-check
                        id="address_option_switch"
                        name="address_option_switch"
                        v-model="query.address_option_switch"
                    >
                        {{ $t('label.required') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-check
                        id="name_option"
                        name="name_option"
                        v-model="query.name_option"
                    >
                        {{ $t('label.name_option') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group class="row">
                    <kt-form-check
                        id="name_option_switch"
                        name="name_option_switch"
                        v-model="query.name_option_switch"
                    >
                        {{ $t('label.required') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-check
                        id="email_option"
                        name="email_option"
                        v-model="query.email_option"
                    >
                        {{ $t('label.email_option') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group class="row">
                    <kt-form-check
                        id="email_option_switch"
                        name="email_option_switch"
                        v-model="query.email_option_switch"
                    >
                        {{ $t('label.required') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-section>
        <kt-row>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group>
                    <kt-form-check
                        id="phone_option"
                        name="phone_option"
                        v-model="query.phone_option"
                    >
                        {{ $t('label.phone_option') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
                <kt-form-group class="row">
                    <kt-form-check
                        id="phone_option_switch"
                        name="phone_option_switch"
                        v-model="query.phone_option_switch"
                    >
                        {{ $t('label.required') }}
                    </kt-form-check>
                </kt-form-group>
            </kt-col>
        </kt-row>
    </kt-form-section>

    <kt-form-action class="mt-4">
        <kt-button 
            class="m-2"
            size="md"
            variant="success"
            type="submit"
            v-bind:wide="true"
            id="submit_btn"
        >
            {{ $t('panel.profile.update.wizard.form.btn.submit') }}
        </kt-button>
    </kt-form-action>
</form>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import $ from 'jquery'
import 'bootstrap-switch'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        query: {
            default() {
                return {
                    title: '',
                    amount: '',
                    quantity: 1,
                    description: '',
                    name_option: false,
                    name_option_switch: false,
                    address_option: false,
                    address_option_switch: false,
                    email_option: false,
                    email_option_switch: false,
                    phone_option: false,
                    phone_option_switch: false,
                }
            },
            type: Object
        }
    },
    mounted() {
        $('[data-switch=true]').bootstrapSwitch('size', 'mini')
        $('[data-switch=true]').on('switchChange.bootstrapSwitch', (e, data) => {
            this.query[e.target.id] = data
        }) 
    },
    methods: {
        processImageFile(e) {
            this.query.image = event.target.files[0]
        },
    },
    computed: {
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    cursor: pointer;
    min-width: 200px;
    width: fit-content
}
</style>